import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Md5} from 'ts-md5/dist/md5';
import { Globals } from '.././globals';

@Injectable()
export class announcementService {
  constructor(private http: HttpClient,private _global:Globals) {}
  readonly rootUrl = this._global.siteUrl;
 
  getannouncement(obj){
    var data = "res=1";
    console.log("check datatatat");
    console.log(obj);
    data +=this.makegetStr(obj);
    console.log(data);
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded','No-Auth':'True'});
    return this.http.post(this.rootUrl+'announcement/', data,{ headers: reqHeader});
  }

  makegetStr(obj){
    var str="";
    if(obj){
      for(var i in obj){
          str +="&"+i+"="+encodeURI(obj[i]);
      }
    }
  return str;
  }

  getannouncementCount(Obj){    
    return this.http.post(this.rootUrl + 'announcement/count', Obj);  
  }

  
}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/announcement.service.ts